export enum PopupType {
  ERROR,
  SUCCESS,
  WARN,
}
